import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Logo from './Logo';
import UserProfile from './UserProfile';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

const Header: React.FC = () => {
  const { isLoggedIn, isLoading } = useAuth();
  const location = useLocation();

  return (
    <div className="header-wrapper">
      <header className="face-swap-header">
        <div className="header-container">
          <div className="header-content">
            <NavLink to="/" className="logo-link">
              <Logo />
            </NavLink>
            
            {/* Main Navigation Menu */}
            <nav className="main-nav">
              <NavLink to="/face-swap" 
                className={() => {
                  // 如果当前路径是根路径或 /face-swap，都添加 active 类
                  const isActive = location.pathname === '/' || location.pathname === '/face-swap';
                  return isActive ? 'nav-link active' : 'nav-link';
                }}
              >
                Face Swap
              </NavLink>
              <NavLink to="/image-to-video" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                Video Gen
              </NavLink>
            </nav>
            
            <nav className="header-nav">
              <NavLink
                to="/blog"
                className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
              >
                Blog
              </NavLink>

              <NavLink to="/pricing" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                Pricing
              </NavLink>
              
              {isLoading ? (
                <div className="login-button loading-state">
                  <span className="loading-dots">···</span>
                </div>
              ) : isLoggedIn ? (
                <UserProfile />
              ) : (
                <NavLink to="/login" className="login-button">
                  Log in
                </NavLink>
              )}
            </nav>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;

